import React from "react";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
import JumboApp from "@jumbo/components/JumboApp";
import JumboTheme from "@jumbo/components/JumboTheme";
import JumboDialogProvider from "@jumbo/components/JumboDialog/JumboDialogProvider";
import JumboDialog from "@jumbo/components/JumboDialog";
import JumboRTL from "@jumbo/JumboRTL/JumboRTL";
import { SnackbarProvider } from "notistack";
import AppProvider from "@portal/AppProvider";
import configureStore from "@portal/redux/store";
import { config } from "@portal/config/main";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const store = configureStore();

const PortalProviders = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <AppProvider>
        <JumboApp activeLayout={config.activeLayout}>
          <JumboTheme init={config.theme}>
            <JumboRTL>
              <JumboDialogProvider>
                <JumboDialog />
                <SnackbarProvider
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  maxSnack={3}
                >
                  {children}
                </SnackbarProvider>
              </JumboDialogProvider>
            </JumboRTL>
          </JumboTheme>
        </JumboApp>
      </AppProvider>
    </Provider>
  </QueryClientProvider>
);

export default PortalProviders;
